import { ACTIVE, DISABLED } from '../classnames/design-system';
import { SCROLL_ANCHOR } from './constants';

export class PaginationButton {
  constructor({
    elem,
    page,
    isActive,
    isDisabled,
    onClick
  }) {
    this.page = page;
    this.elem = elem || this.create();
    this.isActive = isActive;
    this.isDisabled = isDisabled;
    this.onClick = onClick;
  }

  create = () => {
    this.elem = document.createElement('a');
    this.elem.className = 'pagination__btn';
    this.elem.dataset.testid = `pagination-${this.page}-btn`;
    this.elem.textContent = this.page;

    return this.elem;
  };

  update = () => {
    if (this.isActive) {
      this.elem.classList.add(ACTIVE);
    }

    if (this.isDisabled) {
      this.elem.classList.add(DISABLED);
    } else {
      this.elem.classList.remove(DISABLED);
      this.elem.href = SCROLL_ANCHOR;
      this.elem.addEventListener('click', this.onClick);
    }

    return this.elem;
  };
}
